import { createMuiTheme } from '@material-ui/core';

const theme = createMuiTheme({
  palette: {
    primaryGreen:  "#a9d92c"
  }
});

export default theme;
